import { useEffect, useState } from "react";
import { FileWarning } from "lucide-react";
import { api } from "@/lib/api";
import { SignableDocumentRow } from "@/components/SignableDocumentRow";
import { ACTA_ADMINISTRATIVA_HISTORY } from "@/constants/testIds";

// Historial completo de Actas Administrativas de esta persona — cada una es un registro
// disciplinario independiente (no una "versión" que reemplaza a la anterior), así que se
// listan todas, más reciente primero, con su fecha de creación y el mismo checklist de
// firma (PDF, enviar a revisión, subir firma física) que usa la Biblioteca de Documentos.
export function ActaAdministrativaHistory({ employeeId, refreshKey }) {
  const [docs, setDocs] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const load = () => {
    api.get(`/employees/${employeeId}/signable-documents`).then(({ data }) => {
      setDocs(data.filter((d) => d.doc_type === "acta_administrativa"));
      setLoaded(true);
    });
  };

  useEffect(load, [employeeId, refreshKey]);

  const handleDownloadPdf = async (doc) => {
    const { data } = await api.get(`/signable-documents/${doc.id}/pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${doc.title}.pdf`;
    a.click();
  };

  if (!loaded || docs.length === 0) {
    return loaded ? (
      <p data-testid={ACTA_ADMINISTRATIVA_HISTORY.emptyState} className="text-charcoal/50 text-sm">
        Sin actas administrativas generadas para esta persona.
      </p>
    ) : null;
  }

  return (
    <div data-testid={ACTA_ADMINISTRATIVA_HISTORY.section} className="space-y-3">
      <p className="text-xs font-semibold text-charcoal/50 uppercase tracking-wide flex items-center gap-1.5">
        <FileWarning className="w-3.5 h-3.5" /> Historial de Actas Administrativas ({docs.length})
      </p>
      {docs.map((d) => (
        <div key={d.id} data-testid={ACTA_ADMINISTRATIVA_HISTORY.row}>
          <p data-testid={ACTA_ADMINISTRATIVA_HISTORY.createdAtLabel} className="text-xs text-charcoal/40 mb-1">
            Generada el {new Date(d.created_at).toLocaleDateString("es-MX", { year: "numeric", month: "long", day: "numeric" })}
          </p>
          <SignableDocumentRow doc={d} onDownloadPdf={handleDownloadPdf} onChanged={load} />
        </div>
      ))}
    </div>
  );
}
